import { render } from "./App.vue?vue&type=template&id=6b6ea51a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6b6ea51a&lang=scss"

import exportComponent from "/Users/johnguanlao/Desktop/wrk/CodeTogether/RSJI-Equity-Actions/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__